import {
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  IconButton,
  TextField,
} from "@mui/material";
import Dialog from "components/NoScrollDialog";
import ifpcLogo from "assets/images/main-logo.png";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useLanguage } from "contexts/language.context";

export default function SendEmailDialog({
  handleClose,
  open,
  audit,
  handleSubmit,
  emailContent,
  setEmailContent,
}) {
  const { label } = useLanguage();
  const supportContacts = Array.isArray(emailContent.contacts)
    ? emailContent.contacts
    : [];

  const updateContact = (index, field, value) => {
    setEmailContent({
      ...emailContent,
      contacts: supportContacts.map((contact, contactIndex) =>
        contactIndex === index ? { ...contact, [field]: value } : contact,
      ),
    });
  };

  return (
    <Dialog fullWidth={true} maxWidth={"lg"} sx={{ p: 1 }} open={open}>
      <DialogTitle>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="start"
          gap={5}
        >
          <MDTypography variant="h4">{label("send-email")}</MDTypography>
          <MDBox display="flex" flexDirection="row" alignItems="center" gap={2}>
            <MDButton
              variant="gradient"
              color="info"
              endIcon={<Icon>send</Icon>}
              onClick={() => {
                handleSubmit(emailContent);
                //generateLink(true);
              }}
            >
              {label("send-button")}
            </MDButton>
            <MDBox
              sx={{ flex: "1" }}
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              gap={1}
            >
              <IconButton onClick={handleClose} sx={{ padding: "0px" }}>
                <Icon>close</Icon>
              </IconButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "0 !important",
          p: 1,
          mt: -1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              value={emailContent.to || ""}
              onChange={(e) => {
                setEmailContent({ ...emailContent, to: e.target.value });
              }}
              label={label("to-email")}
              fullWidth
              type="email"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={emailContent.fromName || ""}
              onChange={(e) =>
                setEmailContent({ ...emailContent, fromName: e.target.value })
              }
              label="Sender name"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              value={emailContent.website || ""}
              onChange={(e) =>
                setEmailContent({ ...emailContent, website: e.target.value })
              }
              label="Website"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={emailContent.cc || ""}
              onChange={(e) => {
                setEmailContent({ ...emailContent, cc: e.target.value });
              }}
              label={label("cc-email")}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={emailContent.subject || ""}
              onChange={(e) => {
                setEmailContent({ ...emailContent, subject: e.target.value });
              }}
              label="Subject"
              fullWidth
              type="text"
            />
          </Grid>
          <Grid item xs={12} sx={{ pb: 1 }}>
            <div
              style={{
                border: "1px solid rgba(0, 0, 0, 0.15)",
                padding: "8px",
                borderRadius: "8px",
              }}
            >
              <MDBox
                sx={{
                  all: "unset !important",
                  fontFamily: `sans-serif !important`,
                  fontSize: "16px !important",
                }}
              >
                Dear&nbsp;&nbsp;
                <TextField
                  variant="outlined"
                  label="Recipient name"
                  value={emailContent.toName || ""}
                  onChange={(e) => {
                    setEmailContent({
                      ...emailContent,
                      toName: e.target.value,
                    });
                  }}
                  type="text"
                />
                ,
                <br />
                <br />
                Hope all is well.
                <br />
                <br />
                Kindly click on the link below to access the 360° Assessment
                Report corresponding to{" "}
                <TextField
                  variant="outlined"
                  label="Report information"
                  value={emailContent.reportInfo || ""}
                  onChange={(e) => {
                    setEmailContent({
                      ...emailContent,
                      reportInfo: e.target.value,
                    });
                  }}
                  sx={{ width: "500px" }}
                  type="text"
                />
                :
                <br />
                <strong style={{ color: "red", fontSize: "24px" }}>→</strong>
                &nbsp;
                <a href="#">
                  https://ifpc-uploads.s3.eu-north-1.amazonaws.com/assessment_reports/ID-dwlrsce71Kerzb7yQBxTVQ%3D%3D_SG-u_AR.pdf{" "}
                </a>
                <br />
                <br />
                <>
                  {supportContacts.length ? (
                    <>
                      If you need any additional information, feel free to
                      contact:
                      <br />
                      <br />
                      {supportContacts.map((contact, index) => (
                        <span key={index}>
                          <TextField
                            variant="outlined"
                            label="Contact name"
                            value={contact.name || ""}
                            onChange={(event) =>
                              updateContact(index, "name", event.target.value)
                            }
                            placeholder="Contact name"
                          />
                          :{" "}
                          <TextField
                            variant="outlined"
                            label="Contact email"
                            value={contact.email || ""}
                            onChange={(event) =>
                              updateContact(index, "email", event.target.value)
                            }
                            placeholder="Email"
                            type="email"
                          />{" "}
                          <TextField
                            variant="outlined"
                            label="Contact phone"
                            value={contact.phone || ""}
                            onChange={(event) =>
                              updateContact(index, "phone", event.target.value)
                            }
                            placeholder="Phone"
                          />
                          <br />
                          <IconButton
                            aria-label="Remove support contact"
                            color="error"
                            size="small"
                            onClick={() =>
                              setEmailContent({
                                ...emailContent,
                                contacts: supportContacts.filter(
                                  (_, contactIndex) => contactIndex !== index,
                                ),
                              })
                            }
                          >
                            <Icon>delete</Icon>
                          </IconButton>
                          <br />
                        </span>
                      ))}
                      <br />
                    </>
                  ) : null}
                  <MDButton
                    size="small"
                    variant="text"
                    color="info"
                    onClick={() =>
                      setEmailContent({
                        ...emailContent,
                        contacts: [
                          ...supportContacts,
                          { name: "", email: "", phone: "" },
                        ],
                      })
                    }
                  >
                    Add support contact
                  </MDButton>
                  <br />
                </>
                Best regards,
                <br />
                <br />
                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  {emailContent.logoUrl ? (
                    <img
                      alt="Account logo"
                      style={{ maxWidth: "120px", maxHeight: "64px" }}
                      src={emailContent.logoUrl}
                    />
                  ) : null}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      flex: 1,
                    }}
                  >
                    <TextField
                      variant="outlined"
                      label="Account number"
                      value={emailContent.accountNumber || ""}
                      onChange={(event) =>
                        setEmailContent({
                          ...emailContent,
                          accountNumber: event.target.value,
                        })
                      }
                      size="small"
                      fullWidth
                    />
                    <TextField
                      variant="outlined"
                      label="Address"
                      value={emailContent.address || ""}
                      onChange={(event) =>
                        setEmailContent({
                          ...emailContent,
                          address: event.target.value,
                        })
                      }
                      size="small"
                      fullWidth
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    marginTop: "12px",
                    fontSize: "11px",
                    color: "#666",
                  }}
                >
                  <img
                    alt="IFPC"
                    style={{
                      width: "34px",
                      height: "34px",
                      objectFit: "contain",
                    }}
                    src={ifpcLogo}
                  />
                  <span>
                    IFPC International | info@ifpc360.com | www.ifpc-intl.com
                    <br />
                    Powered by Coderaas
                  </span>
                </div>
              </MDBox>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
